import { SelectItem } from 'primeng/api';

export const ON_OFF_FILTER: SelectItem[] = [
  {
    label: 'On',
    value: true,
  },
  {
    label: 'Off',
    value: false,
  },
];

export const NONE_OPTION: SelectItem = {
  label: 'None',
  value: null,
};

export const EMPTY_OPTION: SelectItem = {
  label: 'None',
  value: 'null',
};

export enum ErrorMessages {
  GENERAL = 'Something went wrong. Please try again or contact Carelon support',
  NOT_FOUND = 'Record was not found',
  VALIDATION = 'Please specify required values.',
  CONCURRENCY = 'Rule was already updated. Please refresh the table.',
}

export const TooltipMessages: Record<string, string> = {
  'Episodic - INN': 'Servicing Provider is In HP Network',
  'Episodic - OON': 'Servicing Provider is Out of HP Network',
};

export const MultiSelectsWithTooltips: string[] = ['specialty'];
